import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import AccommodationImage from './assets/AccommodationImage.jpg'
import CelebrateUImage from './assets/CelebrateUImage.jpg'
import ConnectImage from './assets/ConnectImage.png'
import TransportationImage from './assets/TransportationImage.png'
import VisitGuideImage from './assets/VisitGuideImage.png'
import { useTranslate } from '@repo/unicity'

const WhyAttend = () => {
    const { translate } = useTranslate()
    const contents = [
        {
            key: 'accommodation',
            title: translate('accommodation'),
            description: translate('accommodation_description'),
            images: [AccommodationImage],
            readMoreLink: 'https://www.impact.co.th/en/visitors#stay-leisure-entertainment'
        },
        {
            key: 'celebrate-u',
            title: translate('celebrate_u'),
            description: translate('celebrate_u_description'),
            images: [CelebrateUImage]
        },
        {
            key: 'connect',
            title: translate('connect_and_collaborate'),
            description: translate('connect_and_collaborate_description'),
            images: [ConnectImage]
        },
        {
            key: 'transportation',
            title: translate('transportation'),
            description: translate('transportation_description'),
            images: [TransportationImage],
            readMoreLink: 'https://www.impact.co.th/en/visitors#transportation-parking'
        },
        {
            key: 'visit-guide',
            title: translate('visit_guide'),
            description: translate('visit_guide_description'),
            images: [VisitGuideImage],
            readMoreLink: 'https://www.hotels.com/go/thailand/best-bangkok-things-to-do'
        }
    ]

    return (
        <Stack>
            <Stack p={'48px 24px'} bgcolor={'primary.main'} justifyContent={'center'} alignItems={'center'}>
                <Typography variant="h1" color="secondary.light" textAlign={'center'} textTransform={'uppercase'}>
                    {translate('why_attend')}
                </Typography>
            </Stack>
            <Stack>
                {contents.map(content => (
                    <Stack key={content.key}>
                        <Stack>
                            {content.images.map(image => (
                                <img src={image} alt={content.title} key={image} />
                            ))}
                        </Stack>
                        <Stack p={'48px 32px'} gap={2}>
                            <Typography variant="h2" textAlign={'center'} textTransform={'uppercase'} color="primary.main">
                                {content.title}
                            </Typography>
                            <Typography variant="body1" textAlign={'center'} color="primary.main">
                                {content.description}
                            </Typography>
                            {content.readMoreLink && (
                                <Stack pt={'8px'} onClick={() => window.open(content.readMoreLink, '_blank')} sx={{ cursor: 'pointer' }} alignItems={'center'}>
                                    <Typography variant="link" textAlign={'center'} color="primary.main">
                                        {translate('read_more')}
                                    </Typography>
                                </Stack>
                            )}
                        </Stack>
                    </Stack>
                ))}
            </Stack>
        </Stack>
    )
}

export default WhyAttend
